import api, { today } from "../../lib/api";
import { toast } from "sonner";

const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;

const saveBlob = (blob, name) => {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
  URL.revokeObjectURL(a.href);
};

export const exportInvoicesCsv = (picked) => {
  const header = ["invoice_no", "date", "party_name", "account_name", "account_no", "vehicle_number", "source", "invoice_type", "status", "amount", "paid", "balance"];
  const lines = [header.join(",")].concat(
    picked.map((i) => [i.invoice_no, i.date, i.party_name, i.account_name, i.account_no, i.vehicle_number, i.source, i.invoice_type, i.doc_status === "cancelled" ? "cancelled" : i.status, i.amount, i.paid_amount, i.balance].map(esc).join(","))
  );
  saveBlob(new Blob([lines.join("\n") + "\n"], { type: "text/csv" }), `invoices_export_${today()}.csv`);
  toast.success(`Exported ${picked.length} invoice${picked.length === 1 ? "" : "s"}`);
};

export const downloadSkippedCsv = (data) => {
  const cols = [...data.headers, "error_reason"];
  const lines = [cols.map(esc).join(","), ...data.skipped.map((s) => [...data.headers.map((h) => s.data[h]), `Row ${s.row}: ${s.reason}`].map(esc).join(","))];
  saveBlob(new Blob(["\ufeff" + lines.join("\r\n")], { type: "text/csv;charset=utf-8" }), `skipped_invoices_${today()}.csv`);
};

export const downloadInvoiceTemplate = () => {
  const header = "date,invoice_number,job_card_number,challan_number,account_name,driver_mobile,amount,invoice_type,settlement,payment_mode,reference,vehicle_number,description";
  const sample = [
    "2026-10-28,TATA-INV-1001,JC00101,CH-1001,Sharma Fleet,9876543210,1500.50,Spare Parts,credit,,,DL01AB1234,Brake pads",
    "2026-10-28,TATA-INV-1002,JC00102,CH-1002,Verma Transport,,2000,DEF,cash,cash,,,DEF top-up",
    "2026-10-28,TATA-INV-1003,JC00103,CH-1003,Gupta Traders,,900.25,Consolidated,bank,upi,UPI8899,,Monthly bill",
  ].join("\n");
  saveBlob(new Blob([header + "\n" + sample + "\n"], { type: "text/csv" }), "tata_invoice_upload_template.csv");
};

// Returns true when cancelled directly, false when sent for approval.
export const cancelInvoice = async (inv, reason, reloadLocks) => {
  const res = await api.post(`/invoices/${inv.id}/cancel`, null, { params: { reason } });
  if (res.data?.status === "pending") { toast.info(res.data.message); reloadLocks(); return false; }
  return true;
};

export const openInvoiceReceipt = async (inv) => {
  if (!inv.receipt_id) return toast.error("No receipt linked to this invoice");
  try {
    const res = await api.get(`/vouchers/${inv.receipt_id}/pdf`, { responseType: "blob" });
    window.open(URL.createObjectURL(res.data));
  } catch { toast.error("Could not open receipt"); }
};
